import { Mui } from "@osu/react-ui";
import { useSelector, shallowEqual } from "react-redux";
import { selectSessionsDropdownOptions } from "../../../../services/submissionPeriod/slices";

function SelectSession({ 
  id = "select-session-for-export", 
  name = "session-to-download", 
  defaultValue,
  session,
  setSession,
  ...rest 
}) {
  const sessions = useSelector(selectSessionsDropdownOptions, shallowEqual);

  const handleChange = (event) => {
    setSession(event.target.value);
  };

  const labelId = id + "-label";

  return (
    <Mui.FormControl {...rest}>
      <Mui.InputLabel id={labelId}>Session</Mui.InputLabel>
      <Mui.Select
        labelId={labelId}
        id={id}
        value={session}
        label="Session"
        onChange={handleChange}
        name={name}
        required
      >
        {sessions.map(({ label, value }, idx) => (
          <Mui.MenuItem key={`${value}-${idx}`} value={value}>
            {label}
          </Mui.MenuItem>
        ))}
      </Mui.Select>
    </Mui.FormControl>
  );
}

export default SelectSession;
